import React, { Component } from 'react';
import { Col, Form, FormGroup, FormControl, ControlLabel, Button } from 'react-bootstrap';


class RefferalSearchIncompanyKennis extends Component {

    render() {
        return (
            <div>
                {/* TODO: Create search on Referentienummer. in all courses en knowledge to add, and filter this per type of page. */}
                <Form horizontal className="refferalSearch">
                    <FormGroup controlId="refferalSearchBox">
                        <Col componentClass={ControlLabel} sm={4}>
                            Referentienummer
                            </Col>
                        <Col sm={4}>
                            <FormControl type="text" name="searchRefferalNumber" />
                        </Col>
                        <Col md={4}>
                            <Button>controleer nr</Button>
                        </Col>
                    </FormGroup>
                    <FormGroup controlId="refferalSearchBoxcomponentClass">
                        <Col componentClass={ControlLabel} sm={4}>
                            Naam bedrijf
                            </Col>
                        <Col sm={8}>
                            <FormControl.Static><i>bedrijfsnaam aan de hand van het nr</i></FormControl.Static>
                        </Col>
                    </FormGroup>
                    <FormGroup controlId="refferalSearchBoxCursus">
                        <Col componentClass={ControlLabel} sm={4}>
                            Naam bijeenkomst
                            </Col>
                        <Col sm={8}>
                            <FormControl.Static><i>naam bijeenkomst aan de hand van het nr</i></FormControl.Static>
                        </Col>
                    </FormGroup>
                </Form>
            </div>
        )
    };

}

export default RefferalSearchIncompanyKennis;


// WEBPACK FOOTER //
// ./src/components/Member/Modules/Kennis/Toevoegen/RefferalSearchIncompanyKennis.js